// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-386594aa]{width:100%;border-collapse:collapse}table[data-v-386594aa],td[data-v-386594aa],th[data-v-386594aa]{border:.5px solid #000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
